export const META_TRAFFIC_PROFILE = 'r2d2m73kn8'
export const PERFORMANCE_MARKETING_TRAFFIC_PROFILE = 'ig88zpd1k7'

export const isMetaProfile = (profile?: string): boolean =>
  profile === META_TRAFFIC_PROFILE

export const isPerformanceProfile = (profile?: string): boolean =>
  profile === PERFORMANCE_MARKETING_TRAFFIC_PROFILE
